export default __webpack_public_path__ + "static/media/logonegativo.07d179b5.svg";